import { navigate } from 'gatsby'

export const redirect = (path: string) => {
  navigate(path)
}

export const replaceUrl = (path: string) => {
  window.history.replaceState('', '', path)
}
